/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.1.4 public/titanic.glb
*/

import React, { useRef, useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'
import { useLoader, useFrame, useThree } from "@react-three/fiber";

export default function Model(props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/titanic.glb')
  const { actions } = useAnimations(animations, group)
  useThree(({ camera }) => {
    camera.position.y = 8;
    camera.position.x = -1;
    camera.position.z = 10;
    camera.lookAt(0, 0, 0);
  });

  useEffect(() => {
    Object.keys(actions).forEach((key) => {
      actions[key].play();
    });
  }, []);
  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <group name="ship" position={[-0.37, 1.71, 0]} scale={[2.91, 1, 0.75]}>
          <mesh name="Cube003" geometry={nodes.Cube003.geometry} material={materials['Material.003']} />
          <mesh name="Cube003_1" geometry={nodes.Cube003_1.geometry} material={materials['Material.002']} />
          <mesh name="Cube003_2" geometry={nodes.Cube003_2.geometry} material={materials['Material.005']} />
          <mesh name="Cube003_3" geometry={nodes.Cube003_3.geometry} material={materials['Material.006']} />
        </group>
        <group name="ocean" position={[-5.5, -0.35, 0]} scale={[16.37, 0.32, 13]}>
          <mesh name="Cube012" geometry={nodes.Cube012.geometry} material={materials['Material.008']} />
          <mesh name="Cube012_1" geometry={nodes.Cube012_1.geometry} material={materials['Material.007']} />
          <mesh name="Cube012_2" geometry={nodes.Cube012_2.geometry} material={materials['Material.012']} />
          <mesh name="Cube012_3" geometry={nodes.Cube012_3.geometry} material={materials['Material.011']} />
          <mesh name="Cube012_4" geometry={nodes.Cube012_4.geometry} material={materials['Material.013']} />
          <mesh name="Cube012_5" geometry={nodes.Cube012_5.geometry} material={materials['Material.014']} />
          <mesh name="Cube012_6" geometry={nodes.Cube012_6.geometry} material={materials['Material.015']} />
          <mesh name="Cube012_7" geometry={nodes.Cube012_7.geometry} material={materials['Material.016']} />
          <mesh name="Cube012_8" geometry={nodes.Cube012_8.geometry} material={materials['Material.017']} />
          <mesh name="Cube012_9" geometry={nodes.Cube012_9.geometry} material={materials['Material.018']} />
        </group>
        <mesh name="text" geometry={nodes.text.geometry} material={materials['Material.019']} position={[-16.09, 0.03, 3.16]} scale={3.05} />
      </group>
    </group>
  )
}

useGLTF.preload('/titanic.glb')
